import { Bolt, DarkModeOutlined, DirectionsCar, Edit, ElectricCar, GrassRounded, GridView, LightMode, LocalCarWash, SvgIconComponent, WaterDrop } from "@mui/icons-material";
import { Box, IconButton, IconProps, InputAdornment, Popover, TextField } from "@mui/material";
import React, { useState } from "react";

export type IconPickerProps = {
    name?: string
    defaultIcon?: string
    value?: string
    onChange?: (value: string | null) => void
}

export const icons: { [name: string]: SvgIconComponent } = {
    bolt: Bolt,
    water: WaterDrop,
    light: LightMode,
    dark: DarkModeOutlined,
    car: DirectionsCar,
    ecar: ElectricCar,
    carwash: LocalCarWash,
    grid: GridView,
    grass: GrassRounded
};
export const iconByName = (name?: string, props?: IconProps) => icons[name] ? React.createElement(icons[name], props) : null;

const iconList: [string, SvgIconComponent][] = [];
for (var i in icons) {
    iconList.push([i, icons[i]]);
}

export function IconPickerButton({ name, value, defaultIcon, onChange }: IconPickerProps) {
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
    const [v, sv] = useState<string | null | undefined>(value);

    return <>
        <IconButton name={name} size="small" onClick={(e) => setAnchorEl(e.currentTarget)}>
            {v && icons[v] ? iconByName(v) : iconByName(defaultIcon) || <Edit />}
        </IconButton>

        <Popover
            id={anchorEl ? 'iconPickerPopover' : undefined}
            open={!!anchorEl}
            anchorEl={anchorEl}
            onClose={() => setAnchorEl(null)}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'center'
            }}
        >
            <Box sx={styles.box}>
                <IconButton color={!v ? 'primary' : undefined} onClick={() => {
                    onChange?.(null);
                    sv(null);
                }}>{iconByName(defaultIcon) || <Edit />}</IconButton>

                {iconList.map(([name, el]) => <div style={styles.btn}>
                    <IconButton color={v === name ? 'primary' : undefined} onClick={() => {
                        onChange?.(name);
                        sv(name);
                    }}>{iconByName(name)}</IconButton>
                </div>)}
            </Box>
        </Popover>
    </>;
}

export default function IconPicker({ value, onChange }: IconPickerProps) {
    return <>
        <TextField
            fullWidth
            placeholder="�������� ������"
            value={value}
            InputProps={{
                readOnly: true,
                endAdornment: <InputAdornment position="end">
                    <IconPickerButton />
                </InputAdornment>
            }}
            variant="outlined"
            size="small"
        />
    </>;
}

const styles = {
    btn: {
        display: 'inline-block'
    },
    box: {
        width: 200, display: 'block', overfloX: 'none'
    }
}